import Login from "./login";
import Logout from "./logout";
import React, { useState } from 'react';
import './authCard.css';

const clientId = '508890783137-6r2bcmgrbhcr9dciqlpqog8998561mku.apps.googleusercontent.com';

function AuthCard() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  return (
    <div className="auth-card">
      {isAuthenticated ? (
        <div>
          <h2>Welcome User!</h2>
        </div>
      ) : (
        <div>
          <h2>Authentication</h2>
            <Login />
        </div>
      )}
    </div>

  );
}

export default AuthCard;